export default __webpack_public_path__ + "static/media/LOGO CABANG DINAS-09.f39bbdfe.png";